const _ = require('./enum');
module.exports = {
  [_.LOW_VALUE]: { id: _.LOW_VALUE, label: 'Low value' },
  [_.CORPORATE]: { id: _.CORPORATE, label: 'Corporate' },
  [_.TRUSTED_BENEFICIARY]: { id: _.TRUSTED_BENEFICIARY, label: 'Trusted beneficiary' },
  [_.RISK_ANALYSIS]: { id: _.RISK_ANALYSIS, label: 'Risk analysis' },
  [_.DELEGATED_AUTHENTICATION]: { id: _.DELEGATED_AUTHENTICATION, label: 'Delegated authentication' },
};
